import RecruitApiClient from '../../RecruitApiClient';
import { IGetCandidatesParams, IUpdateCandidateParams } from './types';

class Api {
  getCandidates = (params: IGetCandidatesParams) =>
    RecruitApiClient.get(`/api/v4/candidates`, params);
  getPreferences = () => RecruitApiClient.get(`/api/v4/ui_preferences?source=candidates`);
  getDensityPreferences = () => RecruitApiClient.get(`/api/v4/ui_preferences?source=universal`);
  postUserPreferences = (params: { limit: number; sort: string; sortOrder: string }) =>
    RecruitApiClient.post(`/api/v4/ui_preferences`, {
      ui_preference: {
        row_count: params.limit,
        sorting: {
          sortBy: params.sort,
          sortOrder: params.sortOrder
        },
        source: `candidates`
      }
    });
  deleteCandidate = (candidateId?: number) =>
    RecruitApiClient.delete(`/api/v4/candidates/${candidateId}`);
  updateCandidate = (candidateId: number, params: IUpdateCandidateParams) =>
    RecruitApiClient.put(`/api/v4/candidates/${candidateId}`, { candidate: params });
  getCountriesStates = () => RecruitApiClient.get('/api/system/v1/countries_states.json');
}

export default new Api();
